import { render, staticRenderFns } from "./gangweizhijiqianzhui.vue?vue&type=template&id=43c1e89d&scoped=true&"
import script from "./gangweizhijiqianzhui.vue?vue&type=script&lang=js&"
export * from "./gangweizhijiqianzhui.vue?vue&type=script&lang=js&"
import style0 from "./gangweizhijiqianzhui.vue?vue&type=style&index=0&id=43c1e89d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c1e89d",
  null
  
)

export default component.exports